exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "img[data-v-aec84cac]{width:100%}.no-link[data-v-aec84cac]{cursor:auto}.yes-link[data-v-aec84cac]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aec84cac","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/page/widgets/CardWidget.vue
// module id = 84
// module chunks = 0 1 2